module.exports = __webpack_public_path__ + "static/media/me.6672c9e5.JPG";